import { useEffect, useState } from 'react';

// Boîte de confirmation intégrée (remplace window.confirm).
let opener = null;

export function confirmDialog(opts) {
  const o = typeof opts === 'string' ? { message: opts } : opts;
  return new Promise((resolve) => {
    if (opener) opener(o, resolve);
    else resolve(window.confirm(o.message)); // repli si l'hôte n'est pas monté
  });
}

export function ConfirmHost() {
  const [state, setState] = useState(null);
  useEffect(() => { opener = (o, resolve) => setState({ ...o, resolve }); return () => { opener = null; }; }, []);
  if (!state) return null;
  const close = (v) => { state.resolve(v); setState(null); };
  return (
    <div className="modal-overlay" style={{ zIndex: 2000 }} onClick={() => close(false)}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ fontFamily: 'Space Grotesk, sans-serif', marginBottom: 8 }}>{state.title || 'Confirmation'}</h2>
        <p style={{ color: 'var(--muted)', marginBottom: 20, lineHeight: 1.5 }}>{state.message}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="btn-ghost" onClick={() => close(false)}>{state.cancelLabel || 'Annuler'}</button>
          <button className={state.danger ? 'btn btn-danger' : 'btn'} style={{ width: 'auto', padding: '0 20px' }} onClick={() => close(true)}>
            {state.confirmLabel || 'Confirmer'}
          </button>
        </div>
      </div>
    </div>
  );
}
